import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'
import { WeveButtonIcon } from '@weve/ui'

import { DragIcon } from '@icons'

export default Vue.extend({
  name: 'WeveDragHandle',
  functional: true,
  render(h, { data }) {
    return h(
      WeveButtonIcon,
      mergeData(data, {
        props: { label: 'Drag' },
        staticClass: 'handle cursor-grab',
      }),
      [h(DragIcon)]
    )
  },
})
